<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('cacheManage.queryConditions') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="cacheManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input
              v-model="cacheManageInfo.conditions.cacheCode"
              :placeholder="$t('cacheManage.enterCacheCode')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="cacheManageInfo.conditions.name"
              :placeholder="$t('cacheManage.enterCacheName')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryCacheMethod">
              {{ $t('cacheManage.query') }}
            </el-button>
            <el-button size="small" @click="_resetCacheMethod">
              {{ $t('cacheManage.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('cacheManage.cacheInfo') }}</div>
      </div>
      <div class="">
        <cache-manage-table
          :caches="cacheManageInfo.caches"
          @flush-cache="_flushCache"
        />
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="cacheManageInfo.total"
          :page-size="cacheManageInfo.conditions.row"
          :current-page="cacheManageInfo.conditions.page"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { listCache, flushCache } from '@/api/dev/cacheManageApi'
import CacheManageTable from '@/components/dev/cacheManage/cacheManageTable.vue'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'CacheManage',
  components: {
    CacheManageTable
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      cacheManageInfo: {
        caches: [],
        total: 0,
        records: 1,
        conditions: {
          id: '',
          cacheCode: '',
          name: '',
          page: 1,
          row: 10,
          shopId: ''
        }
      }
    }
  },
  created() {
    this.cacheManageInfo.conditions.shopId = getShopId()
    this._listCaches(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    async _listCaches(page, rows) {
      this.cacheManageInfo.conditions.page = page
      this.cacheManageInfo.conditions.row = rows
      
      const params = {
        ...this.cacheManageInfo.conditions,
        id: this.cacheManageInfo.conditions.id.trim(),
        cacheCode: this.cacheManageInfo.conditions.cacheCode.trim(),
        name: this.cacheManageInfo.conditions.name.trim()
      }

      try {
        const res = await listCache(params)
        this.cacheManageInfo.total = res.total
        this.cacheManageInfo.records = res.records
        this.cacheManageInfo.caches = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryCacheMethod() {
      this._listCaches(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetCacheMethod() {
      this.cacheManageInfo.conditions.id = ''
      this.cacheManageInfo.conditions.cacheCode = ''
      this.cacheManageInfo.conditions.name = ''
      this._listCaches(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    async _flushCache(cache) {
      try {
        const res = await flushCache({ cache: cache.url })
        if (res.code === 0) {
          this.$message.success(this.$t('cacheManage.flushSuccess'))
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error(error)
      }
    },
    handlePageChange(currentPage) {
      this._listCaches(currentPage, this.cacheManageInfo.conditions.row)
    },
    handleSizeChange(pageSize) {
      this._listCaches(1, pageSize)
    }
  }
}
</script>

<style scoped>

</style>